import Button from './lib/button';
import Overlay from './lib/overlay';

class NavMain {
  constructor() {
    this.button = new Button();
    this.overlay = new Overlay();
  }

  // eslint-disable-next-line class-methods-use-this
  isCssPropEqual(context, element, prop, value) {
    if (
      getComputedStyle(context.querySelector(element)).getPropertyValue(
        prop
      ) !== value
    ) {
      return true;
    }

    return false;
  }

  // eslint-disable-next-line class-methods-use-this
  getColorBelowElement(el) {
    const rect = el.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    const elements = document.elementsFromPoint(centerX, centerY);

    for (let i = 0; i < elements.length; i++) {
      if (elements[i] !== el && !el.contains(elements[i])) {
        const style = getComputedStyle(elements[i]);
        const bg = style.backgroundColor;
        const bgImage = style.backgroundImage;

        if (bgImage && bgImage !== 'none' && /gradient/.test(bgImage)) {
          return '#ffffff';
        }

        if (bg && bg !== 'transparent' && bg !== 'rgba(0, 0, 0, 0)') {
          const isWhite =
            bg === 'rgb(255, 255, 255)' || bg === 'rgba(255, 255, 255, 1)';
          const isDefault = bg === 'rgb(234, 231, 220)';

          if (isWhite || isDefault) {
            return '#003dbb';
          }

          return '#ffffff';
        }
      }
    }

    return '#003dbb';
  }

  // eslint-disable-next-line class-methods-use-this
  applyNavColors(navItems, getColor) {
    navItems.forEach((item) => {
      const anchor = item.tagName === 'A' ? item : item.querySelector('a');
      const target = anchor || item;
      const color = getColor(item);
      target.style.color = color;
    });
  }

  setButton() {
    const { button, isCssPropEqual, getColorBelowElement } = this;

    Drupal.behaviors.mobileNavBtn = {
      attach(context, settings) {
        const language = settings.path.currentLanguage || 'de';
        const target = '.layout-container > header';
        const wrapper = '.layout-sidebar-first';

        once('mobile-nav-btn', target).forEach((element) => {
          const btn = button.create(element, 'menu', language);
          let throttleTimer = null;

          button.onTabOrClick(btn, wrapper);

          if (isCssPropEqual(context, wrapper, 'position', 'static')) {
            btn.style.display = 'none';
          }

          const updateBtnColor = () => {
            const color = getColorBelowElement(btn);
            btn.style.backgroundColor = color;
          };

          updateBtnColor();

          window.addEventListener('scroll', () => {
            if (throttleTimer) {
              return;
            }

            throttleTimer = setTimeout(() => {
              updateBtnColor();
              throttleTimer = null;
            }, 100);
          });

          window.addEventListener('resize', () => {
            if (throttleTimer) {
              return;
            }

            throttleTimer = setTimeout(() => {
              const windowWidth = window.innerWidth;

              if (windowWidth >= 1210) {
                btn.style.display = 'none';
              } else {
                btn.style.display = 'block';
                updateBtnColor();
              }

              throttleTimer = null;
            }, 100);
          });
        });
      }
    };
  }

  setOverlay() {
    const { button, isCssPropEqual, overlay } = this;

    Drupal.behaviors.mobileNavOverlay = {
      attach(context, settings) {
        const target = '.layout-sidebar-first';

        once('mobile-nav-overlay', target).forEach((element) => {
          const btn = button.create(element, 'cross', null);
          let throttleTimer = null;

          const injectedClass = 'menu--main__overlay-item';

          const addOverlayItems = () => {
            if (element.querySelector(`.${injectedClass}`)) {
              return;
            }

            const sidebarSecond = document.querySelector(
              '.layout-sidebar-second'
            );

            if (sidebarSecond) {
              Array.from(sidebarSecond.children).forEach((child) => {
                const clone = child.cloneNode(true);
                clone.classList.add(
                  injectedClass,
                  'menu--main__overlay-sidebar-second'
                );
                element.append(clone);
              });
            }
          };

          const removeOverlayItems = () => {
            element
              .querySelectorAll(`.${injectedClass}`)
              .forEach((item) => item.remove());
          };

          button.onTabOrClick(btn, target);

          const syncOverlayItems = () => {
            if (element.classList.contains('menu--main__overlay__show')) {
              addOverlayItems();
            } else {
              removeOverlayItems();
            }
          };

          const overlayObserver = new MutationObserver(syncOverlayItems);
          overlayObserver.observe(element, {
            attributes: true,
            attributeFilter: ['class']
          });

          const updateOverlayState = () => {
            const windowWidth = window.innerWidth;
            if (windowWidth < 1210) {
              element.classList.add('menu--main__overlay');
              btn.style.display = 'block';
            } else {
              element.classList.remove('menu--main__overlay');
              element.classList.remove('menu--main__overlay__show');
              btn.style.display = 'none';
              removeOverlayItems();
            }
          };

          updateOverlayState();

          window.addEventListener('resize', () => {
            if (throttleTimer) {
              return;
            }

            throttleTimer = setTimeout(() => {
              updateOverlayState();
              throttleTimer = null;
            }, 100);
          });
        });
      }
    };
  }

  setNavColors() {
    const { getColorBelowElement, applyNavColors } = this;

    Drupal.behaviors.navMainColors = {
      attach() {
        const navs = document.querySelectorAll(
          'nav.navigation.menu--main, nav.navigation.menu--sub'
        );

        if (!navs.length) {
          return;
        }

        const getNavItems = () =>
          Array.from(navs).flatMap((nav) =>
            Array.from(nav.querySelectorAll('ul li'))
          );

        let scrollThrottle = null;
        let resizeThrottle = null;

        const clearNavColors = () => {
          getNavItems().forEach((item) => {
            const anchor =
              item.tagName === 'A' ? item : item.querySelector('a');
            const target = anchor || item;
            target.style.color = '';
          });
        };

        const updateColors = () => {
          const windowWidth = window.innerWidth;
          if (windowWidth < 1210) {
            clearNavColors();
            return;
          }
          applyNavColors(getNavItems(), getColorBelowElement);
        };

        updateColors();

        window.addEventListener('scroll', () => {
          if (scrollThrottle) {
            return;
          }

          scrollThrottle = setTimeout(() => {
            updateColors();
            scrollThrottle = null;
          }, 100);
        });

        window.addEventListener('resize', () => {
          if (resizeThrottle) {
            return;
          }

          resizeThrottle = setTimeout(() => {
            updateColors();
            resizeThrottle = null;
          }, 100);
        });
      }
    };
  }

  run() {
    this.setButton();
    this.setOverlay();
    this.setNavColors();
  }
}

export default NavMain;
